<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :row-class-name="rowClassName"
      :columns="tableColumns"
      :height="tableHeight"
      size="mini"
      :expand-config="{ reserve: true }"
      resizable
      border
      row-id="shipmentPayStatementCode"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
      :header-cell-style="headerCellStyle"
    >
      <template v-slot:toolbar_form>
        <div class="side-frame-warning">
          <span style="font-size: 18px; color: #606266">{{
            $l('form_label_shipmentPayStatement') || '付款结算单'
          }}</span>

          <el-divider direction="vertical"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            @click="batchDel()"
          >
            <i class="el-icon-delete"></i>
            {{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:append="{ row }">
        <el-tag size="mini" :type="row.isAppend === 'Y' ? '' : 'info'">
          {{ row.v_isAppend }}
        </el-tag>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.shipmentPayStatementStatus === 'D' ||
            row.shipmentPayStatementStatus === 'R'
              ? 'danger'
              : row.shipmentPayStatementStatus === 'S'
              ? 'warning'
              : row.shipmentPayStatementStatus === 'Y'
              ? 'success'
              : row.shipmentPayStatementStatus === 'W'
              ? ''
              : ''
          "
        >
          {{ row.v_shipmentPayStatementStatus }}
        </el-tag>
      </template>

      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <i class="el-icon-delete tool-btn" @click="del(row)"></i>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {},
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    errorKeys: { type: Array, default: () => [] },
    tableHeight: { type: Number, default: 400 },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      rowClassName: ({ row }) => {
        const { shipmentPayStatementCode } = row
        if (!this.errorKeys || !this.errorKeys.length) return ''
        const index = this.errorKeys.findIndex(
          (key) => key === shipmentPayStatementCode
        )
        return index < 0 ? '' : 'bg-danger text-white'
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          width: 60,
          slots: {
            default: 'opt',
          },
        },
        {
          title:
            this.$l('table_label_shipmentPayStatementNo') || '付款结算单编号',
          field: 'shipmentPayStatementNo',
          width: 150,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: true,
        },
        {
          title:
            this.$l('table_label_shipmentPayStatementStatus') || '账单状态',
          field: 'shipmentPayStatementStatus',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
          slots: { default: 'status' },
        },
        {
          title: this.$l('table_label_shipmentContractNo') || '外运编号',
          field: 'shipmentContractNo',
          width: 150,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_shipmentNo') || '发运单编号',
          field: 'shipmentNo',
          width: 150,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_expenseCust') || '费用客户',
          field: 'expenseCustName',
          minWidth: 250,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_customer') || '客户',
          field: 'custName',
          minWidth: 250,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },

        {
          title: this.$l('table_label_partyType') || '结算方类型',
          field: 'v_payTo',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_party') || '结算方',
          field: 'payScmName',
          minWidth: 250,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_payer') || '付款方',
          field: 'payerName',
          minWidth: 250,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_payScmBankName') || '结算方开户银行',
          field: 'bankName',
          minWidth: 250,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('table_label_payScmBankAccountName') || '结算方账户名称',
          field: 'bankAccountName',
          minWidth: 260,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_payScmBankAccountNo') || '结算方银行账号',
          field: 'bankAccountNo',
          minWidth: 250,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('table_label_payScmBankAccountType') ||
            '结算方银行账户性质',
          field: 'v_bankAccountType',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
        },
        {
          title:
            this.$l('table_label_payScmBankAccountKind') ||
            '结算方银行账号类别',
          field: 'v_bankAccountKind',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_currencyUnit') || '货币单位',
          field: 'v_currencyUnit',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_currencyTotalAmount') || '费用合计',
          field: 'v_currencyTotalAmount',
          width: 150,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_paymentMethod') || '付款方式',
          field: 'v_paymentMethod',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_isAppend') || '是否为追加费用',
          field: 'isAppend',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
          slots: { default: 'append' },
        },
        {
          title: this.$l('table_label_remark') || '账单说明',
          field: 'remark',
          minWidth: 350,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_created_by') || '创建人',
          field: 'createByName',
          headerAlign: 'center',
          align: 'center',
          width: 140,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_created_date') || '创建时间',
          field: 'createTime',
          headerAlign: 'center',
          align: 'center',
          width: 170,
          showHeaderOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_modified_by') || '修改人',
          field: 'modifyByName',
          headerAlign: 'center',
          align: 'center',
          width: 140,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_modification_date') || '修改时间',
          field: 'modifyTime',
          headerAlign: 'center',
          align: 'center',
          width: 170,
          showHeaderOverflow: true,
        },
      ],
    }
  },
  methods: {
    headerCellStyle({ column }) {
      if (column.property !== 'xxx') {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff',
        }
      }
    },
    getCheckboxRecords() {
      const data = this.$refs.table.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据!!',
          type: 'warning',
        })
        return
      }
      return data
    },
    del(row) {
      this.$emit('delete', [row])
    },
    batchDel() {
      const data = this.getCheckboxRecords()
      if (!data) return
      this.$emit('delete', data)
    },
  },
}
</script>
